import { render, staticRenderFns } from "./pointDecoration.vue?vue&type=template&id=73d73f45&"
import script from "./pointDecoration.vue?vue&type=script&lang=js&"
export * from "./pointDecoration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports